import React from 'react';
import { AccountSettingsLayout } from '../../components/ScreenContainer/AccountSettingsLayout';
import { account_settings_data } from '../../data/saccount_settings.data';
import { Box } from '@mui/material';

const AccountSettings = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'stretch',
                width: '100%',
                maxWidth: '100%',
            }}>
            <AccountSettingsLayout menuItems={account_settings_data} />
        </Box>
    );
};

export { AccountSettings };
